function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.00008 13.3334C10.2217 13.3334 12.8334 10.7217 12.8334 7.50008C12.8334 4.27842 10.2217 1.66675 7.00008 1.66675C3.77842 1.66675 1.16675 4.27842 1.16675 7.50008C1.16675 10.7217 3.77842 13.3334 7.00008 13.3334Z",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.75 5.75L5.25 9.25",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.25 5.75L8.75 9.25",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCloseIconPortfolio = function SvgCloseIconPortfolio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIconPortfolio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseIconPortfolio.20bff45f.svg";
export { ForwardRef as ReactComponent };